import React from "react";
import BackdropUI from "@material-ui/core/Backdrop";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

import { Lottie } from "..";
import chartFile from "../../assets/lotties/lf30_editor_iwcvtddu.json";
import { BackdropProps } from "../../utils/types/components";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  }),
);

export const Backdrop = ({
  open,
  variant = "geslub",
  children,
}: BackdropProps): React.ReactElement => (
  <BackdropUI className={useStyles().backdrop} open={open}>
    {variant === "geslub" && (
      <Lottie animationData={chartFile} height={200} width={200} />
    )}
    {children}
  </BackdropUI>
);
